/****************************************************
 * Module Name:  addUsersettingsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import "./../../style/modalstyle.css";
import { Box, Button, TextField, FormControlLabel, FormGroup, Switch } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddUsersettingsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newusername: this.props.sourceData.username,
      newmemoperioddays: this.props.sourceData.memoperioddays,
      newpaymentperioddays: this.props.sourceData.paymentperioddays,
      newmaxallowedamount: this.props.sourceData.maxallowedamount,
      newmemoreminderperioddays: this.props.sourceData.memoreminderperioddays,
      newpaymentreminderperioddays: this.props.sourceData
        .paymentreminderperioddays,
      newstocksearchcriteria: this.props.sourceData.stocksearchcriteria,
      openInvoicePdf: this.props.sourceData.openinvoicepdf,
      showError: false,

      showStockSearchCriteria: false,
      stockCriteriaStored: "",

      memoPeriodValidationError: "",
      paymentPeriodValidationError: "",
      maxMemoAmountValidationError: "",
      memoReminderDaysValidationError: "",
      paymentReminderDaysValidationError: "",

      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
      ),
    };
  }

  handleSave = () => {
    let data = {
      userid: this.props.sourceData.userid,
      memoperioddays: this.state.newmemoperioddays,
      paymentperioddays: this.state.newpaymentperioddays,
      maxallowedamount: this.state.newmaxallowedamount,
      memoreminderperioddays: this.state.newmemoreminderperioddays,
      paymentreminderperioddays: this.state.newpaymentreminderperioddays,
      stocksearchcriteria: this.state.newstocksearchcriteria,
      openinvoicepdf: this.state.openInvoicePdf,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  buttonDisable = () => {
    if (
      this.state.newmaxallowedamount.length === 0 ||
      this.state.newmemoperioddays.length === 0 ||
      this.state.newmemoreminderperioddays.length === 0 ||
      this.state.newpaymentperioddays.length === 0 ||
      this.state.newpaymentreminderperioddays.length === 0 ||
      this.state.memoPeriodValidationError.length !== 0 ||
      this.state.paymentPeriodValidationError.length !== 0 ||
      this.state.maxMemoAmountValidationError.length !== 0 ||
      this.state.memoReminderDaysValidationError.length !== 0 ||
      this.state.paymentReminderDaysValidationError.length !== 0
    )
      return true;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add user settings validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Edit User Settings
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <Form.Label >Username</Form.Label>
                    </td>
                    <td>
                      <Form.Label style={{ fontWeight: 'bold' }}>{this.props.sourceData.username}</Form.Label>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Memo Period Days <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Memo Period Days (required)"
                        placeholder=" Enter Memo Period Days"
                        value={this.state.newmemoperioddays}
                        onChange={(e) =>
                          this.setState({
                            newmemoperioddays: e.target.value,
                            memoPeriodValidationError: Utility.CheckisNumberGreaterThanZero(
                              e.target.value
                            )
                              ? ""
                              : "Memo Period days should be a Valid number greater than 0",
                          })
                        }
                        helperText={this.state.memoPeriodValidationError}
                        error={this.state.memoPeriodValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Payment Days <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Payment Days (required)"
                        size="small"
                        placeholder=" Enter Payment Days"
                        value={this.state.newpaymentperioddays}
                        onChange={(e) =>
                          this.setState({
                            newpaymentperioddays: e.target.value,
                            paymentPeriodValidationError: Utility.CheckisNumberGreaterThanZero(
                              e.target.value
                            )
                              ? ""
                              : "Payment days should be a Valid number greater than 0",
                          })
                        }
                        helperText={this.state.paymentPeriodValidationError}
                        error={
                          this.state.paymentPeriodValidationError.length > 0
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Max Allowed Memo Amount{" "}
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Max Allowed Memo Amount (required)"
                        size="small"
                        placeholder=" Enter Maximum Allowed Memo Amount"
                        value={this.state.newmaxallowedamount}
                        onChange={(e) =>
                          this.setState({
                            newmaxallowedamount: e.target.value,
                            maxMemoAmountValidationError: Utility.CheckisNumberPositive(
                              e.target.value
                            )
                              ? ""
                              : "Max Allowed Memo Amount should be a Valid positive number",
                          })
                        }
                        helperText={this.state.maxMemoAmountValidationError}
                        error={
                          this.state.maxMemoAmountValidationError.length > 0
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Memo Reminder Period Days{" "}
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Memo Reminder Period Days (required)"
                        size="small"
                        placeholder="Enter Memo Reminder Period Days"
                        value={this.state.newmemoreminderperioddays}
                        onChange={(e) =>
                          this.setState({
                            newmemoreminderperioddays: e.target.value,
                            memoReminderDaysValidationError:
                              Utility.CheckisNumberGreaterThanZero(
                                e.target.value
                              ) &&
                                parseInt(e.target.value) <=
                                parseInt(
                                  this.state.newmemoperioddays ||
                                  this.props.sourceData.memoperioddays
                                )
                                ? ""
                                : "Memo Reminder Period days should be a Valid number greater than 0 and less than or equal to Memo Period Days",
                          })
                        }
                        helperText={this.state.memoReminderDaysValidationError}
                        error={
                          this.state.memoReminderDaysValidationError.length > 0
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Payment Reminder Days{" "}
                        <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Payment Reminder Days (required)"
                        size="small"
                        placeholder="Enter Payment Reminder Days"
                        value={this.state.newpaymentreminderperioddays}
                        onChange={(e) =>
                          this.setState({
                            newpaymentreminderperioddays: e.target.value,
                            paymentReminderDaysValidationError:
                              Utility.CheckisNumberGreaterThanZero(
                                e.target.value
                              ) &&
                                parseInt(e.target.value) <=
                                parseInt(
                                  this.state.newpaymentperioddays ||
                                  this.props.sourceData.newpaymentperioddays
                                )
                                ? ""
                                : "Payment Reminder Period days should be a Valid number greater than 0 and less than or equal to Payment Days",
                          })
                        }
                        helperText={
                          this.state.paymentReminderDaysValidationError
                        }
                        error={
                          this.state.paymentReminderDaysValidationError.length >
                          0
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Open Invoice PDF
                      </Form.Label>
                    </td>
                    <td>
                      <FormGroup sx={{ mt: -0.5, ml: 2, }}>
                        <FormControlLabel
                          control={
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                              <Switch
                                checked={this.state.openInvoicePdf}
                                onChange={() => {
                                  this.setState({ openInvoicePdf: !(this.state.openInvoicePdf) });
                                }}
                              />
                            </Box>
                          }
                          label=""
                        />
                      </FormGroup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            {(Utility.isUpdateAllowed(this.state.local_Permission)) ? (
              <LoadingButton
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
